/* Pre-order: marks add-to-cart forms when the chosen variant is out of stock or the
   requested quantity exceeds stock, and writes the "Pre-order" cart attribute before
   checkout so the payment rule can hide cash on delivery. */
(function () {
  if (window.__preorderInit) return;
  window.__preorderInit = true;

  var cartQty = {};

  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartQty = {};
        (cart.items || []).forEach(function (i) {
          cartQty[i.variant_id] = (cartQty[i.variant_id] || 0) + i.quantity;
        });
      })
      .catch(function () {});
  }

  function update(form) {
    try {
      var dataEl = form.querySelector('.preorder-data');
      var prop = form.querySelector('.preorder-prop');
      if (!dataEl || !prop) return;
      var map = JSON.parse(dataEl.textContent);
      var idInput = form.querySelector('input[name="id"]');
      var id = idInput ? idInput.value : '';
      var v = map[id];
      var on = false;
      var partial = false;
      var stock = 0;
      if (v && v.m && v.a) {
        stock = Math.max(v.q, 0);
        var qtyInput = form.querySelector('input[name="quantity"]') ||
          (form.id ? document.querySelector('input[name="quantity"][form="' + form.id + '"]') : null);
        var want = (parseInt(qtyInput && qtyInput.value, 10) || 1) + (cartQty[id] || 0);
        if (v.q < 1) {
          on = true;
        } else if (want > v.q) {
          on = true;
          partial = true;
        }
      }
      prop.disabled = !on;
      var note = form.querySelector('.preorder-note');
      if (note) {
        if (partial) {
          note.textContent = (note.getAttribute('data-partial') || '').replace('[n]', stock);
          note.hidden = false;
        } else {
          note.hidden = true;
        }
      }
    } catch (e) {}
  }

  function updateAll() {
    document.querySelectorAll('form').forEach(function (f) {
      if (f.querySelector('.preorder-data')) update(f);
    });
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(updateAll, 60);
  }

  ['change', 'input', 'click'].forEach(function (ev) {
    document.addEventListener(ev, schedule, true);
  });

  // Right before the theme builds FormData for /cart/add (capture phase runs first).
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.querySelector && f.querySelector('.preorder-data')) {
      update(f);
      setTimeout(function () { loadCart().then(updateAll); }, 1500);
    }
  }, true);

  // Checkout: make sure every made-to-order line carries the "Pre-order" property
  // (the payment rule hides COD by it) and list them in the cart attribute for staff.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;
    if (btn.getAttribute('data-preorder-done') === '1') {
      btn.removeAttribute('data-preorder-done');
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    // One element per cart line (drawer and cart page may both be in the DOM).
    var lines = {};
    document.querySelectorAll('.preorder-line[data-line]').forEach(function (el) {
      lines[el.getAttribute('data-line')] = el;
    });
    var seen = {};
    var parts = [];
    var fixes = [];
    Object.keys(lines).forEach(function (l) {
      var el = lines[l];
      var n = parseInt(el.getAttribute('data-preorder-qty'), 10) || 0;
      var need = n > 0;
      var has = el.getAttribute('data-has-prop') === '1';
      var vid = el.getAttribute('data-variant');
      if (need && !seen[vid]) {
        seen[vid] = true;
        parts.push(el.getAttribute('data-label') + ' × ' + n);
      }
      if (need !== has) fixes.push({ line: parseInt(l, 10), el: el, need: need });
    });
    // Highest line first: a merge after a change never shifts lower line numbers.
    fixes.sort(function (a, b) { return b.line - a.line; });
    var chain = Promise.resolve();
    fixes.forEach(function (f) {
      chain = chain.then(function () {
        var props = {};
        if (f.need) props['Pre-order'] = f.el.getAttribute('data-prop-value') || 'Pre-order';
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: f.line, quantity: parseInt(f.el.getAttribute('data-quantity'), 10) || 1, properties: props })
        }).catch(function () {});
      });
    });
    chain
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Pre-order': parts.join('; ') } })
        });
      })
      .catch(function () {})
      .then(function () {
        btn.setAttribute('data-preorder-done', '1');
        btn.click();
      });
  }, true);

  loadCart().then(updateAll);
  document.addEventListener('DOMContentLoaded', updateAll);
})();
